import { render, staticRenderFns } from "./sidebar-layout.vue?vue&type=template&id=6ccf58d0"
import script from "./sidebar-layout.vue?vue&type=script&lang=js"
export * from "./sidebar-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports